module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    attrs: {
      "size": "small",
      "model": _vm.rule,
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Title",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.rule.title),
      callback: function($$v) {
        _vm.$set(_vm.rule, "title", $$v)
      },
      expression: "rule.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Event",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Please select an event"
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.rule.events),
      callback: function($$v) {
        _vm.$set(_vm.rule, "events", $$v)
      },
      expression: "rule.events"
    }
  }, _vm._l((_vm.ruleFields.events), function(ruleEvent, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": ruleEvent.title,
        "value": key
      }
    })
  }), 1)], 1), _vm._v(" "), _vm._l((_vm.rule.actions), function(action, key) {
    return _c('rule-action', {
      key: key,
      attrs: {
        "actionKey": _vm.rule.events.actions,
        "action": action,
        "eventActions": _vm.ruleFields.events[_vm.rule.events].actions,
        "fields": _vm.ruleFields.actions
      }
    })
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ced00d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/rules/Rule.vue
// module id = 3196
// module chunks = 3